/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * The enum email state enum
 */
export enum EnumEmailState {
    /**
     * The not started enum email state
     */
    NotStarted = 1,
    /**
     * The pending enum email state
     */
    Pending = 2,
    /**
     * The success enum email state
     */
    Success = 3,
    /**
     * The failure enum email state
     */
    Failure = 4,
    /**
     * The canceled enum email state
     */
    Canceled = 5,
    /**
     * The email was suppressed due to recipient preferences or policies
     */
    Suppressed = 6,
    /**
     * The email bounced back as undeliverable
     */
    Bounced = 7,
    /**
     * The email was quarantined by security filters
     */
    Quarantined = 8,
    /**
     * The email was filtered as spam
     */
    FilteredSpam = 9,
}
